// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilBlack":"#2c2e2f","h1":"style_h1__2zzhs"};